import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { NewsItem, NewsItemDto } from '@app/store/shared/models';
import { NewsItemValue, NewsItemValueDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getNewsItem(id: string): Observable<NewsItem> {
        return this.httpClient.get<NewsItemDto>(`news/${id}`).pipe(map((dto) => new NewsItem(dto)));
    }

    createNewsItem(value: NewsItemValue): Observable<NewsItem> {
        const dto = new NewsItemValueDto(value);

        return this.httpClient.post<NewsItemDto>('news', dto).pipe(map((response) => new NewsItem(response)));
    }

    updateNewsItem(id: string, value: NewsItemValue): Observable<NewsItem> {
        const dto = new NewsItemValueDto(value);

        return this.httpClient.patch<NewsItemDto>(`news/${id}`, dto).pipe(map((response) => new NewsItem(response)));
    }

    deleteNewsItem(id: string): Observable<void> {
        return this.httpClient.delete<void>(`news/${id}`);
    }
}
